import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import { PriceChangeData, UpdatePriceChangeRequest } from '../_types/price-change.types';

@Injectable({
  providedIn: 'root'
})
export class SettingsHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getRegions() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-regions';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getDispenseMode(machine_id) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-vend-mode/'+machine_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCupDrop(machine_id) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-cup-drop/'+machine_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log("Get Cup Drop: ", err.response);
				observer.error(err);
			});
		});
	}

	getFetchFileTypes() {
		return new Observable((observer: any) => {
			const path = '/dashboard/fetch-file-type';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	remoteFetchFiles(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/fetch-log';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	remoteOutOfOrder(content): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/remote-ooorder';
			const params = {
				body: content
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	remoteVouchers(content): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/remote-vouchers';
			const params = {
				body: content
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	changeVendMode(content): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/vend-mode';
			const params = {
				body: content
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getFreeVendMode(machine_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-free-vend-mode/' + machine_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	changeFreeVendMode(content): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/free-vend-mode';
			const params = {
				body: content
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	changeCupDrop(content): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/cup-drop';
			const params = {
				body: content
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result.data);
			}).catch(err => {
				console.log("CUP DROP", err.response);
				observer.error(err);
			});
		});
	}

	getTerritories(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-territories';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getInCompVersions(comp): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/incompatibles';
			const params = {
				body: {
					comp
				}
			};
			API.post(this.apiName, path, params).then(lists => {
				const verArray = [];
				for (const list of lists) {
					verArray.push(list.file_version);
				}
				observer.next(verArray);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineDet(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_machine_info/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCampusLocation(campus_id: string): Observable<any>{
		return new Observable((observer: any) =>{
			const path = '/dashboard/get-camp/' + campus_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err =>{
				console.log(observer.err);
				observer.error(err);
			});
		});
	}

	getCalibSettings(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-calib-settings/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineSettings(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-settings/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getPriceChange(machine_id: string): Observable<PriceChangeData> {
		return new Observable((observer: any) => {
			const path = '/dashboard/price_change/' + machine_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMenuPrices(formObj: UpdatePriceChangeRequest): Observable<PriceChangeData> {
		return new Observable((observer: any) => {
			const path = '/dashboard/price_change';
			const params = {
				body: formObj
			};
			API.put(this.apiName, path, params).then(res => {
				observer.next(res.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getShadowData(serial_no: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-shadow-data/' + serial_no;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMachineSettings(formObj) {
		return new Observable((observer: any) => {
			const path = '/dashboard/update-settings';
			const params = {
				body: formObj
			};
			API.put(this.apiName, path, params).then(res => {
				observer.next(res);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMachineDet(formObj) {
		return new Observable((observer: any) => {
			const path = '/dashboard/update_mac_info';
			const params = {
				body: formObj
			};
			API.put(this.apiName, path, params).then(res => {
				observer.next(res);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getVersion(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_curr_versions/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data[0]);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getAllFiles(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_files_list';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCACodes(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_ca_status_dict';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(ca_codes => {
				const result = {};
				for (const code of ca_codes) {
					result[code.ca_code] = code.code_details;
				}
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	assignLink(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/assign_link';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineKeys(m_id) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_setting/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(keys => {
				observer.next(keys[0]);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineConnState(m_id) {
		return new Observable((observer: any) => {
			const path = '/dashboard/conn-status/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(status => {
				observer.next(status.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	remoteReboot(m_id): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/remote_reboot/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(result => {
				observer.next(result);
				console.log("Result", result)
			}).catch(err => {
				console.log(err.response);
				// console.log("Error", err)
				observer.error(err);
			});
		});
	}

	updateMacKeys(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/save_settings_web';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	testVend(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/remote_test_vend';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	testPrint(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/remote_test_print';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMacKeysMulti(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/machineKeys';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMacConnLogs(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_mac_conn_log/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	deleteCoil(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/delete_coil';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateCoilDet(formObj) {
		return new Observable((observer: any) => {
			console.log(formObj);
			const path = '/dashboard/update_coil_details';
			const params = {
				body: [formObj]
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	send2machineLater(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/update_coildet_shadow';
			const params = {
				body: {obj: formObj}
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	send2machine(m_id): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/snd_coil_details';
			const params = {
				body: {m_id}
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCoilDets(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_coil_dets/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(coil_dets => {
				console.log(coil_dets);
				const result = [];
				const coils = [];
				for (const coil of coil_dets) {
					const ind = coils.indexOf(coil.tray_id);
					if (ind > -1) {
						result[ind].details.push(coil);
					} else {
						coils.push(coil.tray_id);
						result.push({
						tray_id: coil.tray_id,
						details: [coil]
						});
					}
				}
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
